/* global addAriaLabelToDisabledPaymentMethods adyenSupportedBrandCodes isAdyenZppBancontactIntegrationEnabled isTwoPageLoginRegistration customerCartHasSubscription theme */
import 'regenerator-runtime';
import utils from '../helpers/utils';
import { showPageLoader, hidePageLoader, sendAdobeData } from '../../utils';
import validation, {
  VALIDATION_FIELDS,
  WHITELISTED_ORIGIN_PATTERNS,
} from '../helpers/customValidations';
import XRegExp from 'xregexp';
import {
  loadSSOIframe,
  getConfigData,
  setSSOConfig,
  SSO_TIMEOUT,
  URL_REGEX,
  PATH_REGEX,
} from '../../utils/sso';
import initIntTelInput from '../../utils/intlTelInput';
import { logException, logError } from '../../services/sentryService';
import { StreetAndHouseNumberSeparationUtils } from '../helpers/street-and-house-separation';
import { AddressForm } from '../helpers/address-form';
import { InvoiceAddressForm } from '../helpers/invoice-address-form';
import { ApplePayUtils } from '../../utils/applepay-utils';

let pageLoaderTimeout;

/* @ngInject */
function RegisterCtrl(
  $filter,
  $window,
  $timeout,
  $scope,
  $sce,
  RegisterFactory,
  AdobeFactory,
  CustomSelect
) {
  let vm = this;
  let shippingPhoneInstance;
  let invoicePhoneInstance;
  let isTyping = null;
  let typingTimeout = 200;
  let apiKey;
  const allowedExtraKeys = ['Backspace', 'Delete'];
  const houseBeforeCountries = ['FR', 'GB', 'GR', 'IE', 'LU', 'MC'];
  const registrationViews = {
    REGISTRATION: 'registration',
    GUEST: 'guest',
  };
  const twoPageLoginLocalStorageItems = {
    email: 'checkoutEmail',
    view: 'checkoutLoginView',
  };

  const MINIMUM_LENGTH_PASSWORD = 8;
  const MAXIMUM_LENGTH_PASSWORD = 70;
  const PASSWORD_RULE_LIST = [
    /\p{Lu}/u, // Uppercase letters in any language
    /\p{Ll}/u, // Lowercase letters in any language
    /\d/,
    /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/,
  ];
  const MAX_PASSWORD_RULE_COUNT = 3;
  const SHIPPING = 'shipping';
  const INVOICE = 'invoice';

  let autoCompleteNotAvailableCountries = [
    'IE',
    'SI',
    'RO',
    'TR',
    'HR',
    'BG',
    'GR',
    'MT',
    'CY',
  ];
  vm.loginEmailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  vm.registerEmailRegex =
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;
  vm.isAutosuggestionEnabled = false;
  vm.isBraintreeInitialised = false;
  vm.showShippingCountries = false;
  vm.autocompletedFields = false;
  vm.shouldSubmitRegister = true;
  vm.$scope = $scope;
  vm.$timeout = $timeout;
  // Style for the steps below
  vm.style = {
    emptySection: 'empty__section--hidden',
  };

  vm.sectionsModel = {
    email: {
      name: 'email',
      data: {},
      snapshot: {},
      isOpen: true,
      isUsed: false,
    },
    shipping: {
      name: 'shipping',
      data: {},
      snapshot: {},
      isValidated: false,
      isOpen: false,
      isUsed: false,
      showSuggestions: false,
    },
    invoice: {
      name: 'invoice',
      data: {},
      snapshot: {},
      isValidated: false,
      isOpen: false,
      isUsed: false,
      showSuggestions: false,
    },
    payment: {
      name: 'payment',
      data: {
        sepaData: { ownerName: '', iban: '' },
        creditCardData: {},
        bancontactData: {},
      },
      snapshot: {},
      isOpen: false,
      isUsed: false,
    },
    account: {
      name: 'account',
      data: {},
      snapshot: {},
      isOpen: false,
      isUsed: false,
    },
  };
  vm.submit = false;
  vm.paymentValidationInProcess = false;
  vm.error = null;
  vm.cities = [];
  vm.postalCodes = [];
  vm.currentSection = vm.sectionsModel.email;
  vm.previousSection = {};
  vm.ccPattern = /\d{3}/;
  vm.customerRegistered = false;

  vm.countrySelects = {
    shipping: {
      isOpen: false,
      listId: 'shippingDropdown',
      selectedItemId: 'shippingDropdownSelect',
      optionClass: 'js-country__option',
      phoneId: 'shippingPhoneNumber',
      selectedCountry: {},
      name: 'shipping',
      type: 'countryList',
    },
    invoice: {
      isOpen: false,
      listId: 'invoiceDropdown',
      selectedItemId: 'invoiceDropdownSelect',
      optionClass: 'js-country__option',
      phoneId: 'invoicePhoneNumber',
      selectedCountry: {},
      name: 'invoice',
      type: 'countryList',
    },
  };

  vm.autocompleteObjs = {
    postalCodeShipping: {
      isOpen: false,
      listId: 'postalCityShippingList',
      selectedItemId: 'someCodeShp',
      optionClass: 'js-autocompleteItem',
      name: 'shipping',
    },
    cityShipping: {
      isOpen: false,
      listId: 'cityShippingList',
      selectedItemId: 'someCityShp',
      optionClass: 'js-autocompleteItem',
      name: 'shipping',
    },
    streetShipping: {
      isOpen: false,
      listId: 'streetShippingList',
      selectedItemId: 'someStrShp',
      optionClass: 'js-autocompleteItem',
      name: 'shipping',
    },
    postalCodeInvoice: {
      isOpen: false,
      listId: 'postalCityInvoiceList',
      selectedItemId: 'someCodeInv',
      optionClass: 'js-autocompleteItem',
      name: 'invoice',
    },
    cityInvoice: {
      isOpen: false,
      listId: 'cityInvoiceList',
      selectedItemId: 'someCityInv',
      optionClass: 'js-autocompleteItem',
      name: 'invoice',
    },
    streetInvoice: {
      isOpen: false,
      listId: 'streetInvoiceList',
      selectedItemId: 'someStrInv',
      optionClass: 'js-autocompleteItem',
      name: 'invoice',
    },
  };

  vm.$onInit = function () {
    let my = utils.getMonthsAndYears();
    vm.years = my.years;
    vm.months = my.months;

    showPageLoader();
    initializeRegistrationGuestView();

    RegisterFactory.getInitialData()
      .then(function (data) {
        if (data && data.response) {
          vm.countries = data.response.shippingCountries;
          vm.isGuestCheckoutEnabled = data.response.enableGuestCheckout;
          vm.NCDiscount = data.response.newCustomerDiscountExists;
          vm.NCDiscountMessage = data.response.newCustomerDiscountMessage;
          vm.isNewCustomerDiscountApplied = isNewCustomerDiscountApplied(
            vm.NCDiscount
          );
          vm.defaultCountry = data.response.defaultCountry;
          vm.defaultZipCode = data.response.defaultZipCode;
          vm.countrySelects.shipping.selectedCountry =
            data.response.defaultCountry;
          vm.countrySelects.invoice.selectedCountry =
            data.response.defaultCountry;

          StreetAndHouseNumberSeparationUtils.setSeparationFlag(
            data.response.defaultCountry?.iso3166Name
          );

          vm.isAutosuggestionEnabled =
            data.response.addressAutosuggestionEnabled;
          vm.sectionsModel.shipping.data.selectedType = 'NORMAL_ADDRESS';
          vm.shouldCorrectPayment = false;
          validation.setValidationRules(
            VALIDATION_FIELDS.postalCode,
            data.response.postalCodeValidationRules.regExByCountry,
            data.response.postalCodeValidationRules.defaultRegExp
          );

          validation.setValidationRules(
            VALIDATION_FIELDS.street,
            data.response.streetValidationRules.regExByCountry,
            data.response.streetValidationRules.defaultRegExp
          );
          if (StreetAndHouseNumberSeparationUtils.isSeparated()) {
            validation.setValidationRules(
              VALIDATION_FIELDS.houseNumber,
              {},
              data.response.streetValidationRules.defaultRegExp
            );
          }
          validation.setValidationRules(
            VALIDATION_FIELDS.firstName,
            data.response.nameValidationRules.regExByCountry,
            data.response.nameValidationRules.defaultRegExp
          );
          validation.setValidationRules(
            VALIDATION_FIELDS.lastName,
            data.response.nameValidationRules.regExByCountry,
            data.response.nameValidationRules.defaultRegExp
          );
          vm.nameErrorMessages =
            data.response.nameValidationRules.locResourceMessagesByCountry;
          vm.defaultNameErrorMessage =
            data.response.nameValidationRules.defaultLocResourceMessage;
          vm.postalCodeErrorMessages =
            data.response.postalCodeValidationRules.locResourceMessagesByCountry;
          vm.defaultPostalCodeErrorMessage =
            data.response.postalCodeValidationRules.defaultLocResourceMessage;
          vm.streetErrorMessages =
            data.response.streetValidationRules.locResourceMessagesByCountry;
          vm.defaultStreetErrorMessage =
            data.response.streetValidationRules.defaultLocResourceMessage;
          vm.paymentBenefit = data.response.paymentMethodsBenefitMessage;
          vm.paymentUnavailableMessage =
            data.response.paymentMethodsUnavailableMessage;
          vm.sectionsModel.shipping.data.address = {
            postalCode: vm.defaultZipCode,
          };
          vm.showLogin = window.location.href.includes('login');
          vm.showLogin
            ? (vm.sectionsModel.email.data.sectionType = 'LOGIN')
            : (vm.sectionsModel.email.data.sectionType = 'REGISTER');
          setPaymentUnavailableMessage(vm.paymentUnavailableMessage);
          vm.isCustomerRecognized = window.location.href.includes('recognized');
          vm.isCustomerRecognized && setRecognizedUser();
          vm.articleCategories = data.response.articleCategories;
          changeCountryNames();
          initializePhoneInput();
          window.onbeforeunload = beforeUnload;
          window.onpagehide = beforeUnload;
          AdobeFactory.setTrackingAndUpdate();
          setSSOConfig();
          vm.configData = getConfigData();
          loadSSOIframe();
          // Hide the loader in case SSO has failed or thrown an error
          pageLoaderTimeout = setTimeout(() => {
            displayLoginFormAndShopFooter();
            hidePageLoader();
          }, SSO_TIMEOUT);
          window.addEventListener('message', postMessageEventListener, false);
          makeAllCountriesNotAvailableForAddressAutocomplete();
          trackABOWarningVisibility();
        } else {
          vm.hasSSOTechnicalError = true;
          hidePageLoader();
        }
      })
      .catch((err) => {
        logException(err, {
          area: 'registration',
          action: 'RegisterFactory.getInitialData',
        });
        // Hides the page loader in case any error is caught
        hidePageLoader();
      });
  };

  const displayLoginFormAndShopFooter = () => {
    $('.login-form, .login-footer').show();
  };

  function trackABOWarningVisibility() {
    const isGuestPage =
      vm.sectionsModel.email.data.sectionType === 'REGISTER' &&
      !vm.sectionsModel.email.data.createAccount;

    if (theme === 'zooplus' && customerCartHasSubscription && isGuestPage) {
      sendAdobeData(
        'customClickTrack',
        'Checkout',
        'Registration Guest',
        'ABO Warning'
      );
    }
  }

  // Temporary solution to disable AddressAutocomplete feature in all countries
  function makeAllCountriesNotAvailableForAddressAutocomplete() {
    if (vm.countries)
      autoCompleteNotAvailableCountries = vm.countries.map(
        (country) => country.iso3166Name
      );
  }

  function setPaymentUnavailableMessage(message) {
    const paymentUnavailableMsg = document
      .getElementById('js-paymentUnavailableMsg')
      ?.querySelector('.info__text p');

    if (paymentUnavailableMsg) {
      paymentUnavailableMsg.innerText = message;
    }
  }

  const getCustomerEmailAddress = (urlParams) => {
    const customerEmail =
      urlParams.get('email') ||
      localStorage.getItem(twoPageLoginLocalStorageItems.email);
    return customerEmail ? customerEmail : '';
  };

  const isRegularCustomerRegistration = (
    urlSearchParams = new URLSearchParams(window.location.search)
  ) => {
    return (
      location.href.includes('/checkout/register') &&
      urlSearchParams.get('type') !== registrationViews.GUEST
    );
  };

  const isLoginPage = () => {
    return location.href.includes('/checkout/login');
  };

  function initializeRegistrationGuestView() {
    if (isTwoPageLoginRegistration) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      vm.sectionsModel.email.data.createAccount =
        isRegularCustomerRegistration(urlSearchParams);
      vm.sectionsModel.email.data.email =
        getCustomerEmailAddress(urlSearchParams);
    } else {
      vm.sectionsModel.email.data.createAccount = true;
    }
  }

  const isNewCustomerDiscountApplied = (newCustomerDiscount) => {
    if (!newCustomerDiscount) return false;

    return isLoginPage() || isRegularCustomerRegistration();
  };

  function beforeUnload() {
    if (vm.emailForm.$dirty && !isLoginTab() && !vm.redirectOutside) return '';
  }

  vm.getCountries = function () {
    if (vm.sectionsModel.shipping.data.selectedType === 'NORMAL_ADDRESS') {
      return vm.countries;
    }
  };

  vm.editSection = function (sectionName, changeToCreateAccount) {
    vm.sectionsModel[sectionName].isOpen = true;
    vm.sectionsModel[sectionName].snapshot = angular.copy(
      vm.sectionsModel[sectionName].data
    );
    if (sectionName === 'shipping')
      vm.sectionsModel[sectionName].snapshot.selectedCountry =
        vm.countrySelects.shipping.selectedCountry;
    else if (sectionName === 'invoice')
      vm.sectionsModel[sectionName].snapshot.selectedCountry =
        vm.countrySelects.invoice.selectedCountry;

    if (vm.currentSection.name !== sectionName)
      vm.previousSection = vm.currentSection;

    vm.currentSection = vm.sectionsModel[sectionName];

    AdobeFactory.setTrafficObjProperty(
      'url',
      $window.location.hostname + '/checkout/register/' + sectionName
    );
    AdobeFactory.setTrackingAndUpdate();

    StreetAndHouseNumberSeparationUtils.setIsShippingForm(sectionName);

    setTabIndexForPhone();
    vm.scrollToSection(sectionName);
    if (changeToCreateAccount) {
      $timeout(function () {
        vm.sectionsModel.email.data.createAccount = true;
      });
    }
    if (vm.sectionsModel[sectionName].data?.unknownCity) {
      vm.sectionsModel[sectionName].data.unknownCity = false;
    }
    vm.showAddressFormBySectionName(sectionName);
  };

  vm.showAddressFormBySectionName = function (sectionName) {
    if (sectionName === SHIPPING) {
      AddressForm.showDeliveryAddressForm(vm);
    } else if (sectionName === INVOICE) {
      InvoiceAddressForm.showInvoiceAddressForm(vm);
    }
  };

  vm.validateEmailForm = function () {
    vm.validatePassword();
    vm.submitEmailForm();
  };

  const isRegisterTab = () =>
    vm.sectionsModel.email.data.createAccount && !isLoginTab();

  vm.validatePassword = function () {
    let passwordFormField = vm.emailForm['password'];

    if (isGuestCustomer()) {
      passwordFormField.$error = {};
      passwordFormField.$setValidity('pattern', true);
    }

    if (
      isRegisterTab() ||
      (isTwoPageLoginRegistration &&
        location.href.includes('/register') &&
        !isGuestCustomer())
    ) {
      passwordFormField.$error = {};
      vm.emailForm.$submitted = true;

      let newPasswordValue = vm.sectionsModel.email.data.password;
      const passwordLength = newPasswordValue?.length;

      let isMinimumLengthValid = passwordLength >= MINIMUM_LENGTH_PASSWORD;
      let isMaximumLengthValid = passwordLength <= MAXIMUM_LENGTH_PASSWORD;

      let ruleCount = PASSWORD_RULE_LIST.filter((rule) =>
        rule.test(newPasswordValue)
      ).length;
      let isRuleCountValid = ruleCount >= MAX_PASSWORD_RULE_COUNT;

      let isPasswordValid =
        isMinimumLengthValid && isMaximumLengthValid && isRuleCountValid;

      passwordFormField.$error.pattern = !isPasswordValid;
      passwordFormField.$setValidity('pattern', isPasswordValid);
    }

    return Object.keys(passwordFormField.$error).length === 0;
  };

  vm.submitEmailForm = function () {
    const isValid = vm.emailForm.$valid;
    vm.isCustomerRecognized = false;

    // Allow to submit when there was an error but only one field changed
    if (
      isValid ||
      (isLoginTab() &&
        !isValid &&
        vm.emailForm.$error.validationError &&
        vm.emailForm.$error.validationError.length === 1 &&
        isLoginTab())
    ) {
      if (isLoginTab()) {
        ssoLogin();
        vm.technicalError = false;
      } else {
        // register tab
        if (isGuestCustomer()) {
          document.getElementById('customerPassword').value = 'x';
        }
        ssoLogin();
      }
      vm.emailForm.$setPristine();
      vm.submit = true;
    } else {
      vm.emailForm.$submitted = true;
      vm.submit = false;
      focusFirstInvalidFormField();
      AdobeFactory.setTrackingErrors(vm.emailForm.$error, 'front');
    }
  };

  const focusFirstInvalidFormField = () => {
    if (vm.emailForm.$invalid) {
      $timeout(function () {
        const firstInvalidField = angular.element(
          document.querySelector('form input.ng-invalid')
        )[0];
        if (firstInvalidField) {
          firstInvalidField.focus();
        }
      }, 0);
    }
  };

  vm.shouldSeparateStreetAndHouseNumber = function () {
    return StreetAndHouseNumberSeparationUtils.isSeparated();
  };

  vm.getStreetAndHouseNumber = function (formType) {
    const userAddress = vm.sectionsModel[formType].data?.address;
    if (!userAddress) return '';

    if (
      StreetAndHouseNumberSeparationUtils.isSeparated() &&
      formType === 'shipping'
    ) {
      return `${userAddress.street} ${userAddress.houseNumber}`;
    }

    return userAddress.street;
  };

  vm.showAddressEditButtons = function (type) {
    return (
      !vm.sectionsModel[type].isValidated &&
      !vm.sectionsModel[type].showSuggestions &&
      vm.sectionsModel[type].data.allSuggestions
    );
  };

  vm.setSelectedAddress = function (type, action) {
    if (action === 'edit') {
      vm.sectionsModel[type].showSuggestions = false;
      vm.editSection(type);
      vm.submit = false;
    } else {
      vm.submit = true;
      if (vm.sectionsModel[type].data.suggestion !== 3) {
        vm.sectionsModel[type].data.validatedAddress =
          vm.sectionsModel[type].data.allSuggestions[
            vm.sectionsModel[type].data.suggestion
          ];
        vm.sectionsModel[type].data.acceptedSuggestion = true;
        if (type === 'shipping') {
          StreetAndHouseNumberSeparationUtils.sendEventsToAdobeAndOptimizely({
            userAddress: vm.sectionsModel[type].data.address,
            suggestedAddress: vm.sectionsModel[type].data.validatedAddress,
            isSuggesstionAccepted: true,
            formType: type,
          });

          setShippingAddressFlow();
        } else setInvoiceAddressFlow();
        vm.error = null;
      } else {
        // Customer chose their address
        vm.sectionsModel[type].data.acceptedSuggestion = false;
        // We set the first suggestion for the backend object
        vm.sectionsModel[type].data.validatedAddress =
          vm.sectionsModel[type].data.allSuggestions[0];
        if (type === 'shipping') {
          StreetAndHouseNumberSeparationUtils.sendEventsToAdobeAndOptimizely({
            userAddress: vm.sectionsModel[type].data.address,
            suggestedAddress: vm.sectionsModel[type].data.validatedAddress,
            isSuggesstionAccepted: false,
            formType: type,
          });
          setShippingAddressFlow();
        } else setInvoiceAddressFlow();
      }
      vm.sectionsModel[type].isValidated = true;
    }
  };

  function validatePaymentForAdyenWithZpp() {
    if (window.Payment && window.Payment.computeAdyenCreditCardFormData) {
      vm.paymentValidationInProcess = true;
      const result = window.Payment.computeAdyenCreditCardFormData();
      /* The function "window.Payment.computeAdyenCreditCardFormData()" from
       * "payment-frontend" returns an object in case the card information is
       * valid, or "null" value if the card information is not valid.
       * The below if-else statement is to check the validity of the card and
       * handle it appropriately. */
      if (result) {
        vm.paymentForm.$submitted = false;
        vm.postData = {};
        vm.sectionsModel.payment.data.creditCardData.encryptedCardNumber =
          result.encryptedCardNumber;
        vm.sectionsModel.payment.data.creditCardData.encryptedExpiryMonth =
          result.encryptedExpiryMonth;
        vm.sectionsModel.payment.data.creditCardData.encryptedExpiryYear =
          result.encryptedExpiryYear;
        vm.sectionsModel.payment.data.creditCardData.encryptedSecurityCode =
          result.encryptedSecurityCode;
        vm.sectionsModel.payment.data.creditCardData.holderName =
          result.holderName;
        vm.sectionsModel.payment.data.creditCardData.storeInVault =
          result.storeInVault;
        vm.sectionsModel.payment.data.creditCardData.creditCardBrand =
          result.creditCardBrand;
        vm.sectionsModel.payment.data.creditCardData.lastFour = result.lastFour;
        vm.postData = angular.copy(
          vm.sectionsModel.payment.data.creditCardData
        );
        vm.paymentValidationInProcess = false;
        sendTrackingAKCardValidationPassed();
        changeSection('account');
      } else {
        vm.paymentValidationInProcess = false;
        sendTrackingAKCardValidationFailed();
        logError(
          'RegisterController - payment information are incomplete or invalid'
        );
      }
      vm.submit = false;
    }
  }

  function validatePaymentForBancontactAdyenWithZpp() {
    if (
      window.Payment &&
      window.Payment.computeBancontactAdyenCreditCardFormData
    ) {
      vm.paymentValidationInProcess = true;
      const result = window.Payment.computeBancontactAdyenCreditCardFormData();
      /* The function "window.Payment.computeAdyenCreditCardFormData()" from
       * "payment-frontend" returns an object in case the card information is
       * valid, or "null" value if the card information is not valid.
       * The below if-else statement is to check the validity of the card and
       * handle it appropriately. */
      if (result) {
        vm.paymentForm.$submitted = false;
        vm.postData = {};
        vm.sectionsModel.payment.data.bancontactData.encryptedCardNumber =
          result.encryptedCardNumber;
        vm.sectionsModel.payment.data.bancontactData.encryptedExpiryMonth =
          result.encryptedExpiryMonth;
        vm.sectionsModel.payment.data.bancontactData.encryptedExpiryYear =
          result.encryptedExpiryYear;
        vm.sectionsModel.payment.data.bancontactData.holderName =
          result.holderName;
        vm.sectionsModel.payment.data.bancontactData.storeInVault =
          result.storeInVault;
        vm.sectionsModel.payment.data.bancontactData.creditCardBrand =
          result.creditCardBrand;
        vm.sectionsModel.payment.data.bancontactData.lastFour = result.lastFour;
        vm.postData = angular.copy(
          vm.sectionsModel.payment.data.bancontactData
        );

        vm.paymentValidationInProcess = false;
        changeSection('account');
      } else {
        vm.paymentValidationInProcess = false;
        logError(
          'RegisterController - payment information are incomplete or invalid'
        );
      }
      vm.submit = false;
    }
  }

  /**
   * Send a tracking event after the validation is completed for an Adyen credit
   * card and the card information is valid.
   */
  function sendTrackingAKCardValidationPassed() {
    AdobeFactory.setCartObjProperty(
      false,
      'payment_method',
      '',
      vm.selectedPayment
    );
  }

  /**
   * Send a tracking event after the validation is completed for an Adyen credit
   * card and the card information is invalid.
   */
  function sendTrackingAKCardValidationFailed() {
    AdobeFactory.setTrackingErrors(vm.paymentForm.$error, 'front');
  }

  vm.validatePayment = function () {
    if (vm.selectedPayment === 'BS') {
      const isIbanValid = isFieldValid(vm.paymentForm, 'iban');
      const isOwnerNameValid = isFieldValid(vm.paymentForm, 'ownerName');
      if (!isIbanValid || !isOwnerNameValid) {
        vm.submit = false;
        AdobeFactory.setTrackingErrors(vm.paymentForm.$error, 'front');
        return;
      }

      const { hasError, error } = validateIbanAccountName();
      if (hasError) {
        vm.error = utils.setErrors([error], vm.paymentForm);
        AdobeFactory.callTracking('payment_tracking', {
          type: 'OneName_error',
          error: error.defaultMessage,
        });
        vm.submit = false;
        return;
      }

      let cleanIban = vm.sectionsModel.payment.data.sepaData.iban.replace(
        /\s+/g,
        ''
      );
      vm.ibanData = {
        ownerName: vm.sectionsModel.payment.data.sepaData.ownerName,
        iban: cleanIban,
      };
      RegisterFactory.validateIban(vm.ibanData).then(function (data) {
        if (data && data.response && data.response.validationSuccessful) {
          AdobeFactory.setCartObjProperty(
            false,
            'payment_method',
            '',
            vm.selectedPayment
          );
          AdobeFactory.cleanTrackingNotifications();
          changeSection('account');
          let ibanLength = cleanIban.length;
          vm.shownIban = utils.maskStringToShow(
            cleanIban.substr(ibanLength - 4),
            ibanLength - 3
          );
          vm.shouldCorrectPayment = false;
        } else {
          if (data && data.response && data.response.errors) {
            vm.error = utils.setErrors(data.response.errors, vm.paymentForm);
            AdobeFactory.setTrackingErrors(data.response.errors, 'back');
          }
        }
        vm.submit = false;
      });
    } else if (vm.selectedPayment === 'AK') {
      validatePaymentForAdyenWithZpp();
    } else if (vm.selectedPayment === 'BK') {
      if (window.Payment && window.Payment.braintreeTokenizeCard) {
        vm.paymentValidationInProcess = true;
        window.Payment.braintreeTokenizeCard()
          .then((result) => {
            vm.paymentForm.$submitted = false;
            vm.postData = {};
            vm.sectionsModel.payment.data.creditCardData.braintreeCardType =
              result.data.details.cardType.toLowerCase();
            vm.sectionsModel.payment.data.creditCardData.braintreeCardholderName =
              result.data.details.cardholderName;
            vm.sectionsModel.payment.data.creditCardData.braintreeLastFourNumber =
              result.data.details.lastFour;
            vm.sectionsModel.payment.data.creditCardData.braintreeExpirationMonth =
              result.data.details.expirationMonth;
            vm.sectionsModel.payment.data.creditCardData.braintreeExpirationYear =
              result.data.details.expirationYear;
            vm.sectionsModel.payment.data.creditCardData.braintreeNonce =
              result.data.nonce;
            vm.sectionsModel.payment.data.creditCardData.braintreeBinData =
              result.data.binData;
            vm.sectionsModel.payment.data.creditCardData.braintreeBin =
              result.data.details.bin;
            vm.sectionsModel.payment.data.creditCardData.braintreeStoreCard =
              result.data.storeInVault;

            vm.postData = angular.copy(
              vm.sectionsModel.payment.data.creditCardData
            );
            vm.paymentValidationInProcess = false;
            changeSection('account');
          })
          .catch((error) => {
            vm.paymentValidationInProcess = false;
            console.error(error);
            return;
          });
        vm.submit = false;
      } else {
        logError(
          'RegisterController - Cannot tokenize with Braintree as the function braintreeTokenizeCard is not available'
        );
      }
    } else if (vm.selectedPayment === 'BC') {
      if (isAdyenZppBancontactIntegrationEnabled) {
        validatePaymentForBancontactAdyenWithZpp();
      } else {
        if (cardValidations('BC')) {
          vm.submit = false;
          AdobeFactory.setTrackingErrors(vm.paymentForm.$error, 'front');
          return;
        }

        generateAdyenData('BC');
        vm.paymentForm.$submitted = false;
        AdobeFactory.setCartObjProperty(
          false,
          'payment_method',
          '',
          vm.selectedPayment
        );
        changeSection('account');
        vm.submit = false;
        vm.shouldCorrectPayment = false;
      }
    } else {
      AdobeFactory.setCartObjProperty(
        false,
        'payment_method',
        '',
        vm.selectedPayment
      );
      AdobeFactory.cleanTrackingNotifications();
      vm.shouldCorrectPayment = false;
      changeSection('account');
      vm.submit = false;
      vm.paymentForm.$submitted = false;
      vm.paymentForm.$setPristine();

      if (vm.sectionsModel.payment.data.sepaData)
        vm.sectionsModel.payment.data.sepaData = {};

      if (vm.sectionsModel.payment.data.creditCardData) {
        delete vm.sectionsModel.payment.data.creditCardData.number;
        delete vm.sectionsModel.payment.data.creditCardData.holderName;
        delete vm.sectionsModel.payment.data.creditCardData.expiryMonth;
        delete vm.sectionsModel.payment.data.creditCardData.expiryYear;
        delete vm.sectionsModel.payment.data.creditCardData.cvc;
      }
      if (vm.sectionsModel.payment.data.bancontactData)
        vm.sectionsModel.payment.data.bancontactData = {};
    }
  };

  vm.cleanPaymentForm = function () {
    vm.submit = false;
    vm.paymentForm.$submitted = false;
    utils.cleanForm(vm.paymentForm);
  };

  vm.setSelectedPayment = function (payment) {
    if (vm.selectedPayment === payment) return;

    let defaultForGuest;
    if (vm.availableForGuest.length > 0)
      defaultForGuest = vm.availableForGuest[0];

    if (isGuestCustomer() && !vm.paymentMethods[payment].availableForGuest) {
      if (vm.sectionsModel.payment.data.type === payment) {
        vm.selectedPayment = defaultForGuest;
        vm.sectionsModel.payment.data.type = defaultForGuest;
      }

      // Handle bancontact case
      if (payment === 'BC') {
        if (!vm.paymentMethods.BM.availableForGuest) {
          vm.selectedPayment = defaultForGuest;
          vm.sectionsModel.payment.data.type = defaultForGuest;
        } else {
          vm.selectedPayment = 'BM';
          vm.sectionsModel.payment.data.type = 'BM';
        }
      }
    } else {
      vm.selectedPayment = payment;
      vm.sectionsModel.payment.data.type = payment;
    }
    vm.cleanPaymentForm();
  };

  vm.registerCustomer = function () {
    if (vm.shouldSubmitRegister) {
      vm.shouldSubmitRegister = false;
      if (
        !vm.sectionsModel.shipping.data.sameAsShipping &&
        angular.equals({}, vm.sectionsModel.invoice.data.address)
      ) {
        vm.currentSection = vm.sectionsModel.invoice;
        vm.submit = false;
        vm.shouldSubmitRegister = true;
        AdobeFactory.setTrafficObjProperty(
          'url',
          $window.location.hostname + '/checkout/register/' + 'invoice'
        );
        AdobeFactory.setTrackingAndUpdate();
        return;
      }

      let customerData = {};
      customerData.customer = {
        email: vm.sectionsModel.email.data.email,
        password: vm.sectionsModel.email.data.password,
        type: isGuestCustomer() ? 'WITHOUT_REGISTRATION' : 'NEW_CUSTOMER',
      };
      customerData.subscribeToNewsletter =
        vm.sectionsModel.account.data.subscribeToNewsletter;

      customerData.articleCategories = vm.articleCategories;
      customerData.payment = angular.copy(vm.sectionsModel.payment.data);

      customerData.shippingAddress = createShippingAddressObj();

      // ACCMAG-401: concatenate back the houseNumber to the street field before sending to BE
      if (StreetAndHouseNumberSeparationUtils.isSeparated()) {
        customerData.shippingAddress.address.street =
          StreetAndHouseNumberSeparationUtils.getStreetAndHouseNumber(
            customerData.shippingAddress.address
          );
        delete customerData.shippingAddress.address.houseNumber;
      }

      customerData.invoiceSameAsShipping =
        vm.sectionsModel.shipping.data.sameAsShipping;

      if (!vm.sectionsModel.shipping.data.sameAsShipping) {
        customerData.invoiceAddress = createInvoiceAddressObj();
      }

      if (customerData.payment.type === 'BS')
        customerData.payment.ibanFormDto = vm.ibanData;

      if (customerData.payment.type === 'BC') {
        if (isAdyenZppBancontactIntegrationEnabled) {
          customerData.payment.bancontactZppInput = vm.postData;
        } else {
          customerData.payment.bancontactInput = vm.postData;
          delete customerData.payment.bancontactInput.storeCreditCard;
          delete customerData.payment.bancontactInput.number;
          delete customerData.payment.bancontactInput.cardType;
        }
      }

      if (customerData.payment.type === 'AK') {
        customerData.payment.adyenZppInput = vm.postData;
      }

      if (customerData.payment.type === 'BK') {
        customerData.payment.braintreeInput = vm.postData;
      }

      if (customerData.payment.type === 'ID') {
        customerData.payment = {
          type: customerData.payment.type,
          idealIssuer:
            customerData.payment[customerData.payment.type]?.issuer?.issuerId,
        };
      }

      if (
        customerData.payment.type === 'DP' ||
        customerData.payment.type === 'OP'
      ) {
        customerData.payment = {
          type: customerData.payment.type,
          issuerId:
            customerData.payment[customerData.payment.type].issuer.issuerId,
          issuerName:
            customerData.payment[customerData.payment.type].issuer.issuerName,
        };
      } else if (customerData.payment.type === 'PT') {
        customerData.payment = {
          type: customerData.payment.type,
          issuerId:
            customerData.payment[customerData.payment.type]?.issuer?.issuerId ||
            'none',
          issuerName:
            customerData.payment[customerData.payment.type]?.issuer
              ?.issuerName || 'none',
        };
      }

      delete customerData.invoice;
      delete customerData.address;

      delete customerData.payment.creditCardData;
      delete customerData.payment.bancontactData;
      delete customerData.payment.sepaData;
      delete customerData.payment.ID;
      delete customerData.payment.DP;
      delete customerData.payment.OP;
      delete customerData.payment.PT;
      RegisterFactory.registerCustomer(customerData).then(function (data) {
        if (data && data.response) {
          if (data.success) {
            vm.customerRegistered = true;
            vm.registerErrors = false;
            vm.redirectOutside = true;
            if (isGuestCustomer()) {
              $window.location =
                $window.location.origin + data.response.redirectUrl;
            } else {
              ssoLogin();
            }
          } else {
            // vm.registerErrors = data.response.generalErrors;
            let errorContainer =
              document.getElementsByClassName('js-emptyError');
            if (errorContainer) {
              if (data.response.generalErrors.length > 1) {
                // TODO: Merge all messages in one or show different messages?
              } else if (data.response.generalErrors.length === 1) {
                errorContainer[0].querySelector('.info__text').innerText =
                  data.response.generalErrors[0].message;
                vm.registerErrors = true;
              }
            }

            if (!angular.equals({}, data.response.sectionErrors)) {
              checkValidationErrors(data.response.sectionErrors);
            }
            vm.submit = false;
            vm.shouldSubmitRegister = true;
          }
        } else {
          vm.undefinedError = true;
          vm.submit = false;
          vm.shouldSubmitRegister = true;
          AdobeFactory.setTrafficNotifications('error', 'generalError');
          AdobeFactory.setTrackingAndUpdate();
        }
      });
    }
  };

  vm.navigateToRegister = function () {
    localStorage.setItem(
      twoPageLoginLocalStorageItems.email,
      vm.sectionsModel.email.data.email || ''
    );
    trackTwoPageLoginRegistration('create');
    location.href = '/checkout/register';
  };

  vm.navigateToRegisterFromGuest = function () {
    localStorage.setItem(
      twoPageLoginLocalStorageItems.email,
      vm.sectionsModel.email.data.email || ''
    );
    trackTwoPageLoginRegistration('createFromGuest');
    location.href = '/checkout/register';
  };

  vm.navigateToGuest = function () {
    localStorage.setItem(
      twoPageLoginLocalStorageItems.email,
      vm.sectionsModel.email.data.email || ''
    );
    trackTwoPageLoginRegistration('guest');
    location.href = '/checkout/register?type=guest';
  };

  vm.navigateBackToLogin = function () {
    localStorage.setItem(
      twoPageLoginLocalStorageItems.email,
      vm.sectionsModel.email.data.email || ''
    );
    trackTwoPageLoginRegistration('backtologin');
    window.onbeforeunload = null;
    location.href = '/checkout/login';
  };

  vm.cancelEdit = function (sectionName, form) {
    if (!angular.equals({}, vm.sectionsModel[sectionName].snapshot))
      vm.sectionsModel[sectionName].data =
        vm.sectionsModel[sectionName].snapshot;

    utils.cleanForm(form);

    if (
      vm.isAutosuggestionEnabled &&
      (sectionName === 'shipping' || sectionName === 'invoice') &&
      vm.sectionsModel[sectionName].data.allSuggestions
    ) {
      vm.sectionsModel[sectionName].showSuggestions = true;
      return;
    }

    if (vm.currentSection.name === vm.sectionsModel.invoice.name) {
      if (angular.equals({}, vm.sectionsModel.invoice.snapshot)) {
        vm.sectionsModel.invoice.isUsed = false;
        form.$submitted = false;
        vm.sectionsModel.shipping.data.sameAsShipping = true;
      } else {
        vm.countrySelects.invoice.selectedCountry =
          vm.sectionsModel.invoice.snapshot.selectedCountry;
      }
    }

    if (
      angular.equals({}, vm.previousSection) &&
      vm.currentSection.name === 'shipping' &&
      !vm.sectionsModel.shipping.snapshot.sameAsShipping
    )
      vm.previousSection = vm.sectionsModel.invoice;

    vm.scrollToSection(vm.previousSection.name);
    if (vm.currentSection.name === vm.sectionsModel.shipping.name) {
      vm.countrySelects.shipping.selectedCountry =
        vm.sectionsModel[sectionName].data.selectedCountry;
    }

    if (vm.currentSection.name === vm.sectionsModel.payment.name)
      vm.selectedPayment = vm.sectionsModel.payment.data.type;

    vm.currentSection = vm.previousSection;
    vm.sectionsModel[sectionName].isOpen = false;
    vm.sectionsModel[sectionName].snapshot = {};
    vm.previousSection = {};

    setTabIndexForPhone();
    AdobeFactory.setTrafficObjProperty(
      'url',
      $window.location.hostname + '/checkout/register/' + vm.currentSection.name
    );
    AdobeFactory.setTrackingAndUpdate();
  };

  vm.sectionIsOnEditMode = function (sectionName) {
    return isEditModeOn() && vm.currentSection.name === sectionName;
  };

  vm.showOverlay = function (sectionName) {
    return (
      !isLoginTab() &&
      isEditModeOn() &&
      vm.currentSection.name !== sectionName &&
      (vm.sectionsModel[sectionName].isOpen ||
        vm.sectionsModel[sectionName].isUsed ||
        vm.shouldCorrectPayment)
    );
  };

  vm.matchCard = function (cardName) {
    if (vm.selectedPayment === 'AK') {
      cardName = cardName.toLowerCase().replace(/\s+/g, '');
      if (
        !vm.paymentForm.cardNumber.$ccEagerType &&
        !vm.paymentForm.cardNumber.$ccType
      )
        return true;

      if (vm.paymentForm.cardNumber.$ccType) {
        let type = vm.paymentForm.cardNumber.$ccType
          .toLowerCase()
          .replace(/\s+/g, '');

        return cardName === type;
      } else if (vm.paymentForm.cardNumber.$ccEagerType) {
        let eagerType = vm.paymentForm.cardNumber.$ccEagerType
          .toLowerCase()
          .replace(/\s+/g, '');

        return cardName === eagerType;
      } else {
        return false;
      }
    }
  };

  vm.isAmex = function () {
    if (vm.selectedPayment === 'AK')
      return (
        vm.paymentForm.cardNumber.$ccEagerType === 'American Express' ||
        vm.paymentForm.cardNumber.$ccType === 'American Express'
      );

    return false;
  };

  vm.isPaymentReadonlyAndDisabled = (paymentType) =>
    vm.currentSection.name !== 'payment' || vm.selectedPayment !== paymentType;

  vm.ccMaxLength = function () {
    return vm.isAmex() ? 4 : 3;
  };

  vm.cvcPattern = function () {
    if (vm.isAmex()) vm.ccPattern = /\d{4}/;
    else vm.ccPattern = /\d{3}/;
  };

  vm.changeCustomerSectionType = function (tabName) {
    vm.isCustomerRecognized = false;
    vm.sectionsModel.email.data.sectionType = tabName;
    vm.emailForm.$setPristine();
    utils.cleanForm(vm.emailForm);
    vm.sectionsModel.email.data.password = '';

    if (tabName === 'LOGIN') {
      vm.showPassword = false;
      // Hide steps when on login section
      vm.style.emptySection = 'empty__section--hidden';
      if (vm.sectionsModel.email.data.email)
        setTimeout(function () {
          document.getElementById('customerPassword').focus();
        }, 10);
      else
        setTimeout(function () {
          document.getElementById('customerEmail').focus();
        }, 10);
    } else {
      // REGISTER
      utils.cleanForm(vm.emailForm);
      vm.style.emptySection = 'empty__section';
    }
    vm.hasSSOError = false;
    vm.hasSSOTimeoutError = false;
    vm.hasSSOTechnicalError = false;
    vm.hasSSOAccountDisabledError = false;
    vm.emailForm.$submitted = false;
    vm.submit = false;
    vm.technicalError = false;
    AdobeFactory.setTrafficObjProperty(
      'url',
      $window.location.hostname + '/checkout/register/' + tabName.toLowerCase()
    );
    AdobeFactory.setTrackingAndUpdate('loginRegisterTab');
  };

  vm.getPostalCodeCity = function (event, obj) {
    let selectedCountry =
      vm.countrySelects[obj.name].selectedCountry.iso3166Name;
    if (
      vm.isAutosuggestionEnabled &&
      !autoCompleteNotAvailableCountries.includes(selectedCountry)
    ) {
      if (isTyping != null) $timeout.cancel(isTyping);
      // Delay requests until nothing has being typed for x seconds
      isTyping = $timeout(function () {
        // We do a request when the char was a unicode character, dash, apostrophe or space, 229 For android
        isTyping = null;
        if (
          (event.key.length === 1 && /[a-zA-Z0-9- ]/.test(event.key)) ||
          allowedExtraKeys.includes(event.key) ||
          event.keyCode === 229
        ) {
          let postalCode;
          try {
            if (obj.name === 'invoice')
              postalCode = vm.sectionsModel.invoice.data.address.postalCode;
            else if (obj.name === 'shipping')
              postalCode = vm.sectionsModel.shipping.data.address.postalCode;
          } catch (e) {
            postalCode = '';
          }

          if (postalCode && postalCode.length > 2) {
            let requestData = {
              country: vm.countrySelects[obj.name].selectedCountry.iso3166Name,
              in_zip: postalCode,
            };
            RegisterFactory.getAddressInfo(requestData, apiKey).then(function (
              result
            ) {
              // Filter results that have same zip code and city
              if (result.content) {
                vm.postalCodes = result.content.filter((e, i) => {
                  return (
                    result.content.findIndex((x) => {
                      return (
                        x.out_zip !== '' &&
                        x.out_zip === e.out_zip &&
                        x.out_city !== '' &&
                        x.out_city === e.out_city
                      );
                    }) === i
                  );
                });
                // Highlight query text
                vm.postalCodes = vm.postalCodes.map((item) => {
                  let part = utils.escapeRegexp(postalCode).toUpperCase();
                  item.suggestion =
                    item.out_zip.replace(
                      RegExp(part, 'ig'),
                      '<span class="bold match">' +
                        part.toUpperCase() +
                        '</span>'
                    ) +
                    ' ' +
                    item.out_city.capitalize();
                  return item;
                });

                obj.isOpen = true;
                let list = document.getElementById(obj.listId);
                if (list) list.setAttribute('aria-expanded', 'true');

                CustomSelect.hideOnClickOutside(obj);
              }
            });
          } else {
            postalCode = '';
            vm.postalCodes = [];
          }
        }
      }, typingTimeout);
    }
  };

  vm.getCity = function (event, obj) {
    let selectedCountry =
      vm.countrySelects[obj.name].selectedCountry.iso3166Name;
    if (
      vm.isAutosuggestionEnabled &&
      !autoCompleteNotAvailableCountries.includes(selectedCountry)
    ) {
      if (isTyping != null) $timeout.cancel(isTyping);
      // Delay requests until nothing has being typed for x seconds
      isTyping = $timeout(function () {
        isTyping = null;
        // We do a request when the char was a unicode character, dash, apostrophe or space, 229 For android
        if (
          (event.key.length === 1 &&
            XRegExp("^[\\p{L}-'. ]*$").test(event.key)) ||
          allowedExtraKeys.includes(event.key) ||
          event.keyCode === 229
        ) {
          let city;
          let postalCode;
          try {
            if (obj.name === 'invoice') {
              city = vm.sectionsModel.invoice.data.address.city;
              postalCode = vm.sectionsModel.invoice.data.address.postalCode;
            } else if (obj.name === 'shipping') {
              city = vm.sectionsModel.shipping.data.address.city;
              postalCode = vm.sectionsModel.shipping.data.address.postalCode;
            }
          } catch (e) {
            city = '';
            postalCode = '';
          }

          if (city && city.length > 2) {
            let requestData = {
              country: vm.countrySelects[obj.name].selectedCountry.iso3166Name,
              in_city: city,
              in_zip: postalCode,
            };
            RegisterFactory.getAddressInfo(requestData, apiKey).then(function (
              result
            ) {
              if (result.content) {
                // Filter results that have typed zip code and city
                vm.cities = result.content.filter((e, i) => {
                  return (
                    result.content.findIndex((x) => {
                      return postalCode
                        ? e.out_zip.includes(postalCode) &&
                            x.out_city !== '' &&
                            x.out_city === e.out_city
                        : x.out_city !== '' && x.out_city === e.out_city;
                    }) === i
                  );
                });
                if (
                  vm.cities.length === 1 &&
                  vm.cities[0].out_city.toLowerCase() === city.toLowerCase()
                )
                  vm.cities = [];
                else {
                  // Highlight query text
                  vm.cities = vm.cities.map((item) => {
                    item.suggestion = utils.matchAllTerms(
                      item.out_city.toLowerCase(),
                      utils.escapeRegexpAdvanced(city.toLowerCase())
                    );
                    return item;
                  });
                  obj.isOpen = true;
                  let list = document.getElementById(obj.listId);
                  if (list) list.setAttribute('aria-expanded', 'true');

                  CustomSelect.hideOnClickOutside(obj);
                }
              }
            });
          } else {
            city = '';
            postalCode = '';
            vm.cities = [];
          }
        }
      }, typingTimeout);
    }
  };

  vm.getStreet = function (event, obj) {
    let selectedCountry =
      vm.countrySelects[obj.name].selectedCountry.iso3166Name;
    if (
      vm.isAutosuggestionEnabled &&
      !autoCompleteNotAvailableCountries.includes(selectedCountry)
    ) {
      if (isTyping != null) $timeout.cancel(isTyping);
      // Delay requests until nothing has being typed for x seconds
      isTyping = $timeout(function () {
        isTyping = null;
        // We do a request when the char was a unicode character, number, dash, apostrophe or space, 229 For android
        if (
          (event.key.length === 1 &&
            XRegExp("^[\\p{L}0-9-'. ]*$").test(event.key)) ||
          allowedExtraKeys.includes(event.key) ||
          event.keyCode === 229
        ) {
          let city;
          let postalCode;
          let street = '';
          let houseNumber = '';
          let houseNumBefore = houseBeforeCountries.includes(
            vm.countrySelects[obj.name].selectedCountry.iso3166Name
          );
          try {
            if (obj.name === 'invoice') {
              city = vm.sectionsModel.invoice.data.address.city;
              postalCode = vm.sectionsModel.invoice.data.address.postalCode;
              street = vm.sectionsModel.invoice.data.address.street || '';
            } else if (obj.name === 'shipping') {
              city = vm.sectionsModel.shipping.data.address.city;
              postalCode = vm.sectionsModel.shipping.data.address.postalCode;
              street = vm.sectionsModel.shipping.data.address.street || '';
            }
          } catch (e) {
            city = '';
            postalCode = '';
            street = '';
          }

          if (houseNumBefore) {
            let str = street.split(' ');
            if (str.length >= 1 && /[0-9]/.test(str[0])) {
              houseNumber = str[0];
              str[0] = '';
              street = str.join(' ');
            }
          }
          if (street && street.length > 2) {
            let requestData = {
              country: vm.countrySelects[obj.name].selectedCountry.iso3166Name,
              in_city: city,
              in_zip: postalCode,
              in_street: street,
            };
            RegisterFactory.getAddressInfo(requestData, apiKey).then(function (
              result
            ) {
              if (result.content) {
                // Filter results that have typed zip code and city
                vm.streets = result.content.filter((e, i) => {
                  return (
                    result.content.findIndex((x) => {
                      let hasPC = postalCode
                        ? e.out_zip.includes(postalCode)
                        : true;
                      let hasCity = city ? x.out_city === e.out_city : true;
                      return (
                        hasPC &&
                        hasCity &&
                        x.out_street !== '' &&
                        x.out_street === e.out_street
                      );
                    }) === i
                  );
                });
                // Avoid showing suggestions when the house number is present
                if (!houseNumBefore) {
                  let str = street.split(' ');
                  if (str.length > 1 && /[0-9]/.test(str[str.length - 1])) {
                    str.pop();
                    let userStreet = str.join(' ');
                    vm.streets = vm.streets.filter(
                      (item) =>
                        !(
                          street === item.out_street ||
                          userStreet === item.out_street
                        )
                    );
                  }
                }

                if (
                  vm.streets.length === 1 &&
                  vm.streets[0].out_street.toLowerCase() ===
                    street.toLowerCase()
                )
                  vm.streets = [];
                else {
                  // Highlight query text
                  vm.streets = vm.streets.map((item) => {
                    item.suggestion = utils.matchAllTerms(
                      item.out_street.toLowerCase(),
                      utils.escapeRegexpAdvanced(street.toLowerCase())
                    );
                    if (houseNumBefore)
                      item.suggestion = houseNumber + ' ' + item.suggestion;
                    return item;
                  });
                  obj.isOpen = true;
                  let list = document.getElementById(obj.listId);
                  if (list) list.setAttribute('aria-expanded', 'true');

                  CustomSelect.hideOnClickOutside(obj);
                }
              }
            });
          } else {
            city = '';
            postalCode = '';
            street = '';
            vm.streets = [];
          }
        }
      }, typingTimeout);
    }
  };

  vm.setStreet = function (obj, value, country) {
    vm.autocompletedFields = false;
    if (houseBeforeCountries.includes(country)) {
      let partsUser = obj.split(' ');
      let partsValue = value.split(' ');
      if (
        /[0-9]/.test(partsUser[0]) &&
        partsUser.length > 1 &&
        partsUser[0] !== partsValue[0]
      )
        return partsUser[0] + ' ' + value;
      else return value;
    } else return value;
  };

  vm.returnFocus = function (elem) {
    let input = document.getElementById(elem.selectedItemId);
    if (input)
      setTimeout(function () {
        input.focus();
      }, 100);
  };

  vm.manageEnterKey = function (e, action, sectionName, obj, property, value) {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      if (action === 'edit') vm.editSection(sectionName);

      if (action === 'setValue') obj[property] = value;
    }
  };

  vm.trackAction = function (callName) {
    if (callName === 'guestRegistration') {
      AdobeFactory.setCartObjProperty(
        true,
        'customer',
        'type',
        isGuestCustomer() ? 'guest' : 'register'
      );
      AdobeFactory.setTrackingAndUpdate('customerType');
    }
  };

  vm.showPaymentMessage = function () {
    return (
      vm.isGuestCheckoutEnabled &&
      !isLoginTab() &&
      isGuestCustomer() &&
      vm.paymentUnavailableMessage
    );
  };

  vm.setDisabledPayment = function (payment) {
    return vm.paymentMethods && vm.paymentMethods[payment]
      ? (isGuestCustomer() && !vm.paymentMethods[payment].availableForGuest) ||
          !vm.isPaymentEligibleBasedOnMarketplacePresence(payment)
      : false;
  };

  vm.isPaymentEligibleForSubscription = function (payment) {
    return (
      vm.paymentMethods && vm.paymentMethods[payment]?.isEligibleForSubscription
    );
  };

  vm.isPaymentEligibleBasedOnMarketplacePresence = function (payment) {
    if (vm.cartHasMarketplaceItems === false) {
      return true;
    }
    return vm.paymentMethods[payment]?.isEligibleForMarketplace === true;
  };

  vm.hasEligibleSubscription = function () {
    return (
      vm.paymentMethods &&
      Object.values(vm.paymentMethods).some(
        (method) => method.isEligibleForSubscription && !isGuestCustomer()
      )
    );
  };

  vm.setNoCompatibleBrowser = function (payment) {
    if (payment === 'AP' && !ApplePayUtils.isEnabled()) {
      return true;
    }
  };

  vm.focusPw = function () {
    return (
      isEditModeOn() &&
      vm.currentSection.name === 'email' &&
      vm.sectionsModel.email.data.email !== null
    );
  };

  vm.scrollToSection = function (sectionName) {
    let targetSection = sectionName;

    if (sectionName === 'shipping') {
      targetSection = 'email';
    } else if (sectionName === 'invoice') {
      targetSection = 'shipping';
    } else if (sectionName === 'payment') {
      if (vm.sectionsModel.shipping.data.sameAsShipping)
        targetSection = 'shipping';
      else targetSection = 'invoice';
    } else if (sectionName === 'account') {
      targetSection = 'payment';
    }

    $timeout(() => {
      const element = document.getElementById(`js-${targetSection}__section`);
      window.scroll({
        top: element.offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    });
  };

  vm.setAddressFlow = function (type) {
    if (type === 'invoice') setInvoiceAddressFlow();
    else setShippingAddressFlow();
  };

  function setTabIndexForPhone() {
    try {
      vm.showOverlay('shipping')
        ? shippingPhoneInstance.selectedFlag.setAttribute('tabindex', '-1')
        : shippingPhoneInstance.selectedFlag.setAttribute('tabindex', '0');
      vm.showOverlay('invoice')
        ? invoicePhoneInstance.selectedFlag.setAttribute('tabindex', '-1')
        : invoicePhoneInstance.selectedFlag.setAttribute('tabindex', '0');
    } catch (e) {
      // catch error
    }
  }

  function setShippingAddressFlow() {
    vm.shippingForm.$submitted = false;
    vm.sectionsModel.shipping.hasCancelButton = true;
    if (vm.sectionsModel.shipping.data.sameAsShipping) {
      // Clean invoice data before changing sections when customer reverts choice
      vm.sectionsModel.invoice.data = {};
      vm.countrySelects.invoice.selectedCountry =
        vm.countrySelects.shipping.selectedCountry;
      vm.sectionsModel.invoice.isOpen = false;
      vm.sectionsModel.invoice.isUsed = false;
      AdobeFactory.cleanTrackingNotifications();
      getPaymentMethods(
        vm.countrySelects.shipping.selectedCountry.code,
        'shipping'
      );
    } else {
      if (!vm.sectionsModel.invoice.isUsed) {
        // Set country and change phone country to the default one
        vm.countrySelects.invoice.selectedCountry =
          vm.countrySelects.shipping.selectedCountry;

        let event = new CustomEvent('countryChange', {
          detail: {
            country: vm.countrySelects.shipping.selectedCountry,
            phoneId: vm.countrySelects.invoice.phoneId,
            type: vm.countrySelects.invoice.name,
          },
        });
        window.dispatchEvent(event);
      }

      AdobeFactory.setCartObjProperty(
        true,
        'customer',
        'delivery_address',
        createShippingAddressObj().address
      );
      AdobeFactory.cleanTrackingNotifications();

      setValidatedAddressData('shipping');
      changeSection('invoice');
      vm.sectionsModel.shipping.showSuggestions = false;
      vm.submit = false;
    }
  }

  function setInvoiceAddressFlow() {
    vm.invoiceAddressForm.$submitted = false;
    vm.sectionsModel.invoice.hasCancelButton = true;
    AdobeFactory.cleanTrackingNotifications();
    getPaymentMethods(
      vm.countrySelects.invoice.selectedCountry.code,
      'invoice'
    );
    vm.sectionsModel.invoice.isValidated = true;
  }

  function changeSection(nextSection) {
    // Guest user - empty password
    if (!vm.sectionsModel.email.data.createAccount) {
      vm.sectionsModel.email.data.password = '';
    }

    StreetAndHouseNumberSeparationUtils.setIsShippingForm(nextSection);

    vm.sectionsModel[vm.currentSection.name].isUsed = true;
    vm.sectionsModel[vm.currentSection.name].isOpen = false;
    if (vm.shouldCorrectPayment) {
      vm.currentSection = vm.sectionsModel[nextSection];
      vm.previousSection = {};
      vm.sectionsModel.payment.isOpen = true;
      vm.scrollToSection(vm.currentSection.name);
      AdobeFactory.setTrafficObjProperty(
        'url',
        $window.location.hostname + '/checkout/register/' + nextSection
      );
      AdobeFactory.setTrackingAndUpdate();
      vm.addressSuggestion = false;
      return;
    }

    if (!angular.equals({}, vm.previousSection)) {
      // When we remove invoice after reaching payment
      if (
        vm.previousSection.name === 'invoice' &&
        vm.sectionsModel.shipping.data.sameAsShipping
      ) {
        vm.currentSection = vm.sectionsModel.payment;
        vm.sectionsModel.payment.isOpen = true;
        AdobeFactory.setTrafficObjProperty(
          'url',
          $window.location.hostname + '/checkout/register/' + 'payment'
        );
      } else if (
        nextSection === 'invoice' &&
        !vm.sectionsModel.invoice.isUsed
      ) {
        if (vm.previousSection.name === 'invoice') vm.previousSection = {};

        vm.sectionsModel.invoice.isOpen = true;
        vm.currentSection = vm.sectionsModel.invoice;
        vm.scrollToSection(vm.currentSection.name);
        AdobeFactory.setTrafficObjProperty(
          'url',
          $window.location.hostname +
            '/checkout/register/' +
            vm.currentSection.name
        );
        AdobeFactory.setTrackingAndUpdate();
        InvoiceAddressForm.showInvoiceAddressForm(vm);
        return;
      } else {
        // Fix selected payment method
        if (vm.previousSection.name === 'payment') {
          vm.selectedPayment = vm.availableForGuest[0];
          vm.sectionsModel.payment.data.type = vm.availableForGuest[0];
        }
        vm.currentSection = vm.previousSection;
        AdobeFactory.setTrafficObjProperty(
          'url',
          $window.location.hostname +
            '/checkout/register/' +
            vm.previousSection.name
        );
        vm.sectionsModel[vm.previousSection.name].isOpen = true;
        vm.showAddressFormBySectionName(vm.previousSection.name);
      }
    } else {
      vm.currentSection = vm.sectionsModel[nextSection];
      vm.sectionsModel[nextSection].isOpen = true;
      vm.showAddressFormBySectionName(nextSection);
    }

    vm.previousSection = {};

    AdobeFactory.setTrafficObjProperty(
      'url',
      $window.location.hostname + '/checkout/register/' + nextSection
    );
    setTabIndexForPhone();
    vm.scrollToSection(vm.currentSection.name);
    AdobeFactory.setTrackingAndUpdate();
    vm.sectionsModel.shipping.showSuggestions = false;
    vm.sectionsModel.invoice.showSuggestions = false;
    delete vm.sectionsModel.shipping.data.allSuggestions;
    delete vm.sectionsModel.invoice.data.allSuggestions;
    if (nextSection === 'payment') {
      addAriaLabelToDisabledPaymentMethods();
    }
  }

  function checkValidationErrors(validationErrors) {
    // More sections might come in the future
    if (validationErrors.SHIPPING_ADDRESS) {
      utils.setErrors(validationErrors.SHIPPING_ADDRESS, vm.shippingForm);
      vm.shippingForm.$submitted = true;
      vm.editSection('shipping');
      AdobeFactory.setTrackingErrors(vm.shippingForm.$error, 'front');
      delete validationErrors.SHIPPING_ADDRESS;
    } else if (validationErrors.INVOICE_ADDRESS) {
      utils.setErrors(validationErrors.INVOICE_ADDRESS, vm.invoiceAddressForm);
      vm.invoiceAddressForm.$submitted = true;
      vm.editSection('invoice');
      AdobeFactory.setTrackingErrors(vm.invoiceAddressForm.$error, 'front');
      delete validationErrors.INVOICE_ADDRESS;
    }
  }

  function generateAdyenData(type) {
    vm.postData = {};
    if (type !== 'BC') {
      vm.sectionsModel.payment.data.creditCardData.generationtime =
        vm.adyenDetails.adyenTimeStamp;
      vm.postData = angular.copy(vm.sectionsModel.payment.data.creditCardData);
      vm.postData['adyenEncryptedData'] = vm.cseInstance.encrypt(
        vm.sectionsModel.payment.data.creditCardData
      );

      vm.selectedCardName = $filter('filter')(
        vm.adyenDetails.adyenSupportedCards,
        { brandCode: type }
      )[0].name;
      vm.postData.number = vm.postData.number.substr(
        vm.postData.number.length - 4
      );
      vm.postData.storeCreditCard =
        vm.sectionsModel.payment.data.creditCardData.storeCreditCard;
    } else {
      vm.sectionsModel.payment.data.bancontactData.generationtime =
        vm.adyenDetails.adyenTimeStamp;
      vm.postData = angular.copy(vm.sectionsModel.payment.data.bancontactData);
      vm.postData['bancontactEncryptedData'] = vm.cseInstance.encrypt(
        vm.postData
      );
      vm.postData.bancontactNumber = vm.postData.number.substr(
        vm.postData.number.length - 4
      );
      delete vm.postData.number;
    }
    vm.postData.cardType = type;

    delete vm.postData.cvc;
    delete vm.postData.generationtime;
  }

  function createShippingAddressObj() {
    let addressData = angular.copy(vm.sectionsModel.shipping.data);
    addressData.address.country =
      vm.countrySelects.shipping.selectedCountry.code;

    if (addressData.validatedAddress) {
      addressData.address.state = addressData.validatedAddress.out_region;
      addressData.address.cityDistrict =
        addressData.validatedAddress.out_city_district;
      addressData.uniservAddressValidation = addressData.validatedAddress;
      addressData.uniservAddressValidation.suggestionAccepted =
        addressData.acceptedSuggestion;
    }
    delete addressData.sameAsShipping;
    delete addressData.suggestion;
    delete addressData.validatedAddress;
    delete addressData.selectedCountry;
    delete addressData.isValid;
    delete addressData.acceptedSuggestion;
    delete addressData.allSuggestions;
    return addressData;
  }

  function createInvoiceAddressObj() {
    let addressData = angular.copy(vm.sectionsModel.invoice.data);
    addressData.address.country =
      vm.countrySelects.invoice.selectedCountry.code;

    if (addressData.validatedAddress) {
      addressData.address.state = addressData.validatedAddress.out_region;
      addressData.address.cityDistrict =
        addressData.validatedAddress.out_city_district;
      addressData.uniservAddressValidation = addressData.validatedAddress;
      addressData.uniservAddressValidation.suggestionAccepted =
        addressData.acceptedSuggestion;
    }

    delete addressData.selectedCountry;
    delete addressData.suggestion;
    delete addressData.validatedAddress;
    delete addressData.isValid;
    delete addressData.acceptedSuggestion;
    delete addressData.allSuggestions;
    return addressData;
  }

  function removePaymentMethodsDisabledByBrowser(response) {
    if (!ApplePayUtils.isEnabled()) {
      delete response.paymentMethods[ApplePayUtils.APPLE_PAY];
      response.defaultPaymentMethod = Object.keys(response.paymentMethods)[0];
    }
  }

  function getPaymentMethods(countryCode, type) {
    let data = { invoiceCountry: countryCode };
    let previousPayment = vm.selectedPayment;

    RegisterFactory.getPaymentMethods(data).then(function (result) {
      if (result.success) {
        removePaymentMethodsDisabledByBrowser(result.response);
        if (previousPayment && !result.response.paymentMethods[previousPayment])
          vm.shouldCorrectPayment = true;

        vm.paymentMethods = result.response.paymentMethods;
        vm.cartHasMarketplaceItems = result.response.cartHasMarketplaceItems;

        // Trust HTML content for payment adjustment descriptions
        vm.trustPaymentAdjustmentDescriptions();
        // Create adyen instance
        if (result.response.adyenDetails) {
          vm.adyenDetails = result.response.adyenDetails;
          vm.cseInstance = adyen.createEncryption(
            result.response.adyenDetails.adyenCseKey
          );
          vm.cardBancaireAvailable = $filter('filter')(
            vm.adyenDetails.adyenSupportedCards,
            { brandCode: 'cartebancaire' }
          )[0];
          vm.sectionsModel.payment.data.creditCardData.storeCreditCard = false;
        }

        $timeout(function () {
          sortPaymentMethods();
          selectDefaultPayment(result.response.defaultPaymentMethod);
          utils.initModal();
        });

        selectDefaultPayment(result.response.defaultPaymentMethod);
        selectDefaultIssuer(result.response.paymentMethods);

        if (
          !vm.sectionsModel.payment.data.sepaData.ownerName &&
          (
            vm.sectionsModel.shipping.data.address.firstName +
            ' ' +
            vm.sectionsModel.shipping.data.address.lastName
          ).length <= 30
        ) {
          vm.sectionsModel.payment.data.sepaData.ownerName =
            vm.sectionsModel.shipping.data.address.firstName +
            ' ' +
            vm.sectionsModel.shipping.data.address.lastName;
          vm.prefilledName = true;
        }

        AdobeFactory.setCartObjProperty(
          true,
          'customer',
          'delivery_address',
          createShippingAddressObj().address
        );
        changeSection('payment');
        if (vm.paymentMethods['BK']) {
          if (!vm.isBraintreeInitialised) {
            window.Payment?.braintreeRenderPaymentSwitch();
            vm.isBraintreeInitialised = true;
          }
        }
        if (vm.paymentMethods['AK']) {
          window?.Payment?.renderAdyenCaptureCreditCard(
            vm.getCustomerType(),
            adyenSupportedBrandCodes
          );
        }

        $timeout(function () {
          if (
            vm.paymentMethods['BC'] &&
            isAdyenZppBancontactIntegrationEnabled
          ) {
            window?.Payment?.renderBancontactAdyenCaptureCreditCard(
              vm.getCustomerType()
            );
          }
        });

        vm.submit = false;

        setValidatedAddressData(type);
        vm.sectionsModel[type].showSuggestions = false;
      }
    });
  }

  function setValidatedAddressData(type) {
    if (
      !angular.equals({}, vm.sectionsModel[type].data.validatedAddress) &&
      vm.sectionsModel[type].data.acceptedSuggestion
    ) {
      vm.sectionsModel[type].data.address.street =
        vm.sectionsModel[type].data.validatedAddress.street;

      if (
        StreetAndHouseNumberSeparationUtils.isSeparated() &&
        type === 'shipping'
      ) {
        vm.sectionsModel[type].data.address.street =
          vm.sectionsModel[type].data.validatedAddress.out_str;
        vm.sectionsModel[type].data.address.houseNumber =
          vm.sectionsModel[type].data.validatedAddress.out_hno;
      }

      vm.sectionsModel[type].data.address.postalCode =
        vm.sectionsModel[type].data.validatedAddress.postalCode;
      vm.sectionsModel[type].data.address.city =
        vm.sectionsModel[type].data.validatedAddress.city;
    }
  }

  function selectDefaultPayment(defaultPaymentMethod) {
    let selectedExists = vm.paymentMethods[vm.selectedPayment];
    let defaultPayment = '';
    vm.availableForGuest = Object.keys(vm.paymentMethods).filter(
      (i) => vm.paymentMethods[i].availableForGuest
    );
    if (!selectedExists) {
      angular.forEach(vm.paymentMethods, function (val, key) {
        if (key === defaultPaymentMethod) {
          if (isGuestCustomer() && !val.availableForGuest) {
            if (vm.availableForGuest.length > 0)
              defaultPayment = vm.availableForGuest[0];
          } else {
            defaultPayment = key;
          }
        }
      });
      vm.selectedPayment = vm.sectionsModel.payment.data.type = defaultPayment;
    }
  }

  function selectDefaultIssuer(paymentMethods) {
    // Loop through all paymentMethods with issuer and set the selected issuer to the first issuer to avoid empty option
    for (let paymentMethodKey in paymentMethods) {
      if (
        paymentMethods.hasOwnProperty(paymentMethodKey) &&
        paymentMethods[paymentMethodKey].issuers.length > 0
      ) {
        let paymentMethodWithIssuer = paymentMethods[paymentMethodKey];
        vm.sectionsModel.payment.data[paymentMethodKey] = {
          issuer: paymentMethodWithIssuer.issuers[0],
        };
      }
    }
  }

  function isEditModeOn() {
    return (
      (vm.currentSection.isOpen && vm.currentSection.isUsed) ||
      vm.shouldCorrectPayment ||
      (vm.currentSection.name === 'invoice' &&
        vm.currentSection.isOpen &&
        !vm.currentSection.isUsed &&
        !angular.equals({}, vm.previousSection)) ||
      (vm.currentSection.name === 'invoice' &&
        vm.currentSection.isOpen &&
        vm.currentSection.isUsed)
    );
  }

  function initializePhoneInput() {
    shippingPhoneInstance = initIntTelInput({
      input: document.querySelector('#shippingPhoneNumber'),
      locale: vm.defaultCountry.iso3166Name,
      wrapperClass: '.shippingPhoneNumber',
    });
    invoicePhoneInstance = initIntTelInput({
      input: document.querySelector('#invoicePhoneNumber'),
      locale: vm.defaultCountry.iso3166Name,
      wrapperClass: '.invoicePhoneNumber',
    });
  }

  function changeCountryNames() {
    let countryData = window.intlTelInputGlobals.getCountryData();
    angular.forEach(countryData, function (value) {
      let country = $filter('filter')(vm.countries, {
        iso3166Name: $filter('uppercase')(value.iso2),
      })[0];
      if (country && country.iso3166Name === $filter('uppercase')(value.iso2)) {
        value.name = country.name;
      }
    });
  }

  const isFieldValid = (form, fieldName) =>
    angular.equals({}, vm.paymentForm[fieldName].$error);

  const validateIbanAccountName = () => {
    const accountName = vm.sectionsModel.payment.data.sepaData.ownerName;
    const hasError = accountName.trim().split(/\s+/).length < 2;
    const ibanAccountNameError = {
      field: 'ownerName',
      defaultMessage: 'Please enter your first name and surname',
      message:
        window.frontendErrorMessages &&
        window.frontendErrorMessages['ownerName'],
    };

    return { hasError, error: ibanAccountNameError };
  };

  function cardValidations(selectedType) {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let isDateValid = true;

    if (
      selectedType === 'BC' &&
      typeof vm.paymentForm.bcCardNumber.$viewValue !== 'undefined'
    ) {
      const isCardValid = isFieldValid(vm.paymentForm, 'bcCardNumber');
      const isNameValid = isFieldValid(vm.paymentForm, 'bcCardName');
      isDateValid =
        (vm.sectionsModel.payment.data.bancontactData.expiryYear >
          currentYear &&
          vm.sectionsModel.payment.data.bancontactData.expiryMonth !==
            undefined) ||
        (Number(vm.sectionsModel.payment.data.bancontactData.expiryYear) ===
          currentYear &&
          vm.sectionsModel.payment.data.bancontactData.expiryMonth >=
            currentMonth);
      if (!isDateValid) {
        vm.paymentForm['bcCardMonth'].$error.validationError = true;
        vm.paymentForm['bcCardMonth'].$setValidity('validationError', false);
      } else {
        vm.paymentForm['bcCardMonth'].$error.validationError = false;
        vm.paymentForm['bcCardMonth'].$setValidity('validationError', true);
      }
      return !isDateValid || !isCardValid || !isNameValid;
    } else {
      const isCardSupported = $filter('filter')(
        vm.adyenDetails.adyenSupportedCards,
        { brandCode: selectedType }
      )[0];
      const isCardValid = isFieldValid(vm.paymentForm, 'cardNumber');
      const isCvcValid = isFieldValid(vm.paymentForm, 'cardCode');
      const isNameValid = isFieldValid(vm.paymentForm, 'cardName');
      isDateValid =
        (vm.sectionsModel.payment.data.creditCardData.expiryYear >
          currentYear &&
          vm.sectionsModel.payment.data.creditCardData.expiryMonth !==
            undefined) ||
        (Number(vm.sectionsModel.payment.data.creditCardData.expiryYear) ===
          currentYear &&
          vm.sectionsModel.payment.data.creditCardData.expiryMonth >=
            currentMonth);
      if (!isCardSupported) {
        vm.paymentForm['cardNumber'].$error.validationError = true;
        vm.paymentForm['cardNumber'].$setValidity('validationError', false);
      }
      if (!isDateValid) {
        vm.paymentForm['cardMonth'].$error.validationError = true;
        vm.paymentForm['cardMonth'].$setValidity('validationError', false);
      } else {
        vm.paymentForm['cardMonth'].$error.validationError = false;
        vm.paymentForm['cardMonth'].$setValidity('validationError', true);
      }
      return (
        !isCardSupported ||
        !isDateValid ||
        !isCardValid ||
        !isCvcValid ||
        !isNameValid
      );
    }
  }

  function sortPaymentMethods() {
    let paymentMethods = $('.payment__box .accordion__container');
    let currentElement;
    let newElement;
    if (paymentMethods.children().length > 1) {
      let i = 0;
      angular.forEach(vm.paymentMethods, function (payment, key) {
        currentElement = paymentMethods.children()[i];
        newElement = document.querySelector('[data-zta="input' + key + '"]');
        if (newElement && currentElement && currentElement !== newElement)
          utils.swapElements(currentElement, newElement);

        i++;
      });
    }
  }

  // NEW IMPLEMENTATION

  vm.toggleDropdown = CustomSelect.toggleDropdown;
  vm.handleCountryMouseOver = CustomSelect.handleCountryMouseOver;
  vm.handleMouseLeave = CustomSelect.handleMouseLeave;
  vm.setDropdownCountry = CustomSelect.setDropdownCountry;
  vm.handleKeyDown = CustomSelect.handleKeyDown;

  function setRecognizedUser() {
    let email = sessionStorage.getItem('recognizedCustomerEmail');
    if (email) {
      vm.sectionsModel.email.data.email = email;
      sessionStorage.removeItem('recognizedCustomerEmail');
    }
  }

  const ssoLogin = () => {
    if (!vm.loginSSoUrl) {
      handleSSOTimeout();
      $timeout(() => $scope.$apply, 0);
    } else {
      vm.loginForm = document.getElementById('loginForm');
      vm.loginForm.target = 'sso-iframe';
      vm.loginForm.action = vm.loginSSoUrl;
      if (!vm.loginTimeout)
        vm.loginTimeout = $timeout(handleSSOTimeout, SSO_TIMEOUT);
      if (isTwoPageLoginRegistration) {
        trackTwoPageLoginRegistration('login');
      }
      vm.loginForm.submit();
      showPageLoader();
    }
  };

  const postMessageEventListener = (event) => {
    $timeout.cancel(vm.loginTimeout);
    clearTimeout(pageLoaderTimeout);
    switch (event.data.type) {
      case 'CHALLENGE_PAGE':
        displayLoginFormAndShopFooter();
        hidePageLoader();
        if (!isOriginMatchingWhitelistedOnes(event)) {
          logException(
            'Origin is not among the whitelisted ones.',
            { area: 'sso' },
            { event_data: event.data }
          );
          return;
        }
        vm.loginSSoUrl = null;
        if (
          URL_REGEX.test(event.data.actionUrl) ||
          PATH_REGEX.test(event.data.actionUrl)
        ) {
          vm.loginSSoUrl = event.data.actionUrl;
        }

        if (event.data.message != null) {
          const message = event.data.message.text;
          if (message.includes('timeout')) {
            if (!vm.loginSSoUrl) {
              handleSSOTimeout();
              $timeout(() => $scope.$apply, 0);
            } else {
              vm.loginForm = document.getElementById('loginForm');
              vm.loginForm.action = vm.loginSSoUrl;
              vm.loginForm.submit();
            }
          } else if (message.includes('invalid_credentials')) {
            // login view -> invalid email or password
            // register views -> recognized email and invalid password
            document.getElementById('customerPassword').value = '';
            setSSOError();
          } else if (
            message.includes('unknown_user') ||
            message.includes('invalid_user')
          ) {
            // email not recognized
            if (isLoginTab()) {
              setSSOError();
            } else {
              if (isGuestCustomer()) {
                document.getElementById('customerPassword').value = '';
              }
              proceedRegistration();
            }
          } else if (message.includes('internal_error')) {
            handleSSOTechnicalError();
          } else if (message.includes('account_disabled')) {
            handleSSOAccountDisabledError();
          }
          vm.submit = false;
        }
        break;
      case 'LOGIN_SUCCESS':
        vm.redirectOutside = true;
        if (
          URL_REGEX.test(event.data.path) ||
          PATH_REGEX.test(event.data.path)
        ) {
          location.href = event.data.path;
        } else {
          location.href = '/checkout/preview';
        }
        break;
      case 'ALREADY_AUTHENTICATED':
        location.reload();
        break;
      default:
        if (event.origin.includes('login')) {
          displayLoginFormAndShopFooter();
          hidePageLoader();
          handleSSOTechnicalError();
          logException(
            'Unknown Keycloak event type',
            { area: 'sso' },
            { event_data: event.data }
          );
        }
        break;
    }
  };

  const proceedRegistration = () => {
    vm.emailForm.$submitted = false;
    vm.submit = false;
    vm.sectionsModel.email.isValidated = true;
    AdobeFactory.setTrafficObjProperty(
      'url',
      $window.location.hostname + '/checkout/register/address'
    );
    AdobeFactory.cleanTrackingNotifications();
    if (
      isGuestCustomer() &&
      vm.sectionsModel.payment.isUsed &&
      !vm.paymentMethods[vm.selectedPayment].availableForGuest
    ) {
      vm.shouldCorrectPayment = true;
      vm.setSelectedPayment(vm.availableForGuest[0]);
      changeSection('payment');
    } else if (
      !vm.paymentValidationInProcess &&
      vm.currentSection.name !== 'payment'
    ) {
      changeSection('shipping');
      vm.isCustomerRecognized = false;
    }
  };

  function setSSOError() {
    if (location.pathname.includes('register')) {
      vm.redirectOutside = true;
      sessionStorage.setItem(
        'recognizedCustomerEmail',
        vm.sectionsModel.email.data.email
      );
      $window.location = $window.location.origin + '/checkout/login?recognized';
      return;
    }
    if (!isLoginTab()) {
      if (!vm.customerRegistered) {
        vm.changeCustomerSectionType('LOGIN');
      }
      vm.isCustomerRecognized = true;
      vm.emailForm.$submitted = false;
      vm.submit = false;
      $timeout(() => $scope.$apply, 0);
      // User is registered but SSO triggered an error
      if (vm.customerRegistered) {
        vm.undefinedError = true;
        vm.submit = false;
      }
      return;
    }
    vm.emailForm.$submitted = true;
    vm.error = utils.setErrors(
      [
        { field: 'password', message: '' },
        { field: 'email', message: '' },
      ],
      vm.emailForm
    );
    vm.hasSSOError = true;
    vm.submit = false;
    $timeout(() => $scope.$apply, 0);
    focusFirstInvalidFormField();
  }

  const trackTwoPageLoginRegistration = (action) => {
    AdobeFactory.callTracking('loginRegisterButton', { action });
  };

  const isLoginTab = () => vm.sectionsModel.email.data.sectionType === 'LOGIN';
  vm.isLoginTabActive = () =>
    vm.sectionsModel.email.data.sectionType === 'LOGIN';
  vm.isRegisterTabActive = () =>
    vm.sectionsModel.email.data.sectionType === 'REGISTER';
  const isGuestCustomer = () => !vm.sectionsModel.email.data.createAccount;
  vm.isGuestCustomer = () => isGuestCustomer();
  vm.isRegularCustomer = () =>
    Boolean(vm.sectionsModel?.email?.data?.createAccount);

  vm.getCustomerType = () => {
    return isGuestCustomer() ? 'GUEST_CUSTOMER' : 'NEW_CUSTOMER';
  };

  function handleSSOTimeout() {
    vm.hasSSOTimeoutError = true;
    vm.loginTimeout = null;
    vm.submit = false;
    hidePageLoader();
  }

  function isOriginMatchingWhitelistedOnes(event) {
    return WHITELISTED_ORIGIN_PATTERNS.some((pattern) =>
      pattern.test(event.origin)
    );
  }

  function handleSSOTechnicalError() {
    vm.hasSSOTechnicalError = true;
    hidePageLoader();
    $timeout(() => $scope.$apply, 0);
  }

  function handleSSOAccountDisabledError() {
    vm.hasSSOAccountDisabledError = true;
    hidePageLoader();
    $timeout(() => $scope.$apply, 0);
  }

  vm.clickTracking = function () {
    sendAdobeData(
      'customClickTrack',
      'Checkout',
      'Preview Payment Section',
      'Create Account'
    );
  };

  vm.trustPaymentAdjustmentDescriptions = function () {
    if (!vm.paymentMethods) {
      return;
    }

    Object.keys(vm.paymentMethods).forEach(function (paymentKey) {
      const paymentMethod = vm.paymentMethods[paymentKey];
      const description = paymentMethod?.paymentAdjustmentNoteDescription;

      if (description) {
        paymentMethod.paymentAdjustmentNoteDescription =
          $sce.trustAsHtml(description);
      }
    });
  };
}

export default RegisterCtrl;
